import script from "./FeatureGuidePopover.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureGuidePopover.vue?vue&type=script&setup=true&lang=js"

import "./FeatureGuidePopover.vue?vue&type=style&index=0&id=9f7c4834&scoped=true&lang=css"
import "./FeatureGuidePopover.vue?vue&type=style&index=1&id=9f7c4834&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f7c4834"]])

export default __exports__